<template>
	<TableFilter :scheme-type="enumDef.filterSchemeType.BuyerAllInvestmentsReceivables"
				 :filter-refs="$refs"
				 @apply-filter="applyFilter"
	>
		<div class="filter_item">
			<div class="filter_head">{{ this.$t("common.debtor") }}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="debtorName"
						ref="filter_debtorName"
			></TextFilter>
			<TextFilter :label-text="this.$t('common.riskScore')"
						columnName="debtorCreditsafeRating"
						ref="filter_debtorCreditsafeRating"
			></TextFilter>
			<IndustryFilter :label-text="this.$t('common.industry')"
							columnName="debtorIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="this.$t('common.country')"
						   columnName="debtorCountry"
						   :company-type="enumDef.companyType.DebtorCompany"
						   ref="filter_debtorCountry"
			></CountryFilter>
		</div>
		<div class="filter_item">
			<div class="filter_head">{{ this.$t("common.seller") }}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="sellerName"
						ref="filter_sellerName"
			></TextFilter>
			<TextFilter :label-text="this.$t('common.riskScore')"
						columnName="sellerCreditsafeRating"
						ref="filter_sellerCreditsafeRating"
			></TextFilter>
			<IndustryFilter :label-text="this.$t('common.industry')"
							columnName="sellerIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="this.$t('common.country')"
						   columnName="sellerCountry"
						   ref="filter_debtorCountry"
			></CountryFilter>
		</div>
		<div class="filter_item filter_item_l">
			<div class="filter_head">{{ this.$t("common.receivableDetails") }}</div>
			<EnumFilter :label-text="this.$t('common.type')"
						columnName="receivableType"
						:enum-def="enumDef.receivableType"
						ref="filter_receivableType"
			></EnumFilter>
			<TextFilter :label-text="$t('common.invoiceNumber')"
			            column-name="invoiceNumber"
			            ref="filter_invoiceNumber"
			></TextFilter>
			<FromToFilter :label-text="this.$t('common.amount')"
						  columnName="receivableAmount"
						  ref="filter_receivableAmount"
			></FromToFilter>
			<FromToFilter :label-text="this.$t('common.outstanding.percent')"
			              columnName="outstandingPercentage"
			              ref="filter_outstandingPercentage"
			></FromToFilter>
			<TextFilter :label-text="$t('common.contractNumber')"
						column-name="installmentContractNumber"
						ref="filter_installmentContractNumber"
			></TextFilter>
			<TextFilter :label-text="$t('common.tci.id')"
						column-name="certificateId"
						ref="filter_certificateId"
			></TextFilter>
		</div>
	</TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
	components: {
		TableFilter,
		EnumFilter,
		CountryFilter,
		IndustryFilter,
		FromToFilter,
		TextFilter,
	},
	data() {
		return {
			enumDef: enumDef,
		};
	},
	methods: {
		applyFilter(filters) {
			this.$emit("apply-filter", filters);
		}
	}
};
</script>
